import React, { useState, useEffect } from 'react'
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import { Button, Card, CheckboxToggle, FileSelector, Option, Picklist, Textarea, TimePicker, WeekDayPicker } from 'react-rainbow-components';
import 'react-quill/dist/quill.snow.css';
import { RequestInit, RequestInitWithBody } from '../shared/RequestInit';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import ShowNotification from '../shared/Notification'
import { PicklistInterface } from '../../interfaces/Picklist_interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Weekdayconverter } from './WeekDayConverter';


export interface UpdateEmissionProps {
    location: {
        state: {
            Id: number,
            emission: string,
            emission_Id: number,
            description: string,
            jour: string,
            heure_debut: string,
            heure_Fin: string,
            nom: string,
            active: 0 | 1,
            livecam: 0 | 1,
            planning_active: 0 | 1,
            emission_banniere: string,
            banniere_active: 0 | 1
        }
    }


}

const UpdateFullEmission: React.FC<UpdateEmissionProps> = (props: UpdateEmissionProps) => {

    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday',]
    const jour = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche']

    /* state for the name and description of the emission */
    const [Emission, setEmission] = useState<string>(props.location.state.emission)
    const [Desription, setDesription] = useState<string>(props.location.state.description)
    const [Id, setId] = useState<number>(props.location.state.Id)
    const [Jour, setJour] = useState<string>(props.location.state.jour)
    const [Heure_Debut, setHeure_Debut] = useState<string>(props.location.state.heure_debut.slice(0, -3))
    const [Heure_Fin, setHeure_Fin] = useState<string>(props.location.state.heure_Fin.slice(0, -3))
    const [Nom, setNom] = useState<string>(props.location.state.nom)

    const [Equipe, setEquipe] = useState<[{ Id: number, name: string, image: string }]>([{ Id: 0, name: '', image: '' }])
    const [SelectedEquipe, setSelectedEquipe] = useState<PicklistInterface>({ name: undefined, label: undefined })
    const [SelectedJour, setSelectedJour] = useState<any | undefined>([])
    const [ActiveDays, setActiveDays] = useState<any | undefined>([])

    const [test, setTest] = useState<{}>({})

    /* banniere states */
    /* state for the image from props */
    const [BanniereActive, setBanniereActive] = useState<0 | 1>(props.location.state.banniere_active)

    /* image states */
    /* state for the image url from props */
    const [BanniereIMG, setBanniereIMG] = useState<string>(props.location.state.emission_banniere)
    /* state for the blob that will be send to the server to be uploaded */
    const [BannierUploadedUrl, setBanniereUploadedUrl] = useState<string | Blob>('')
    /* state for upload error */
    const [errorImage, setErrorImage] = useState<string>('')

    /* state for each input field where we set the error message*/
    const [errorDesription, setErrorDesription] = useState<string>('')
    /* loading state for when a user submits an upadte for the emission */
    const [loading, setLoading] = useState<boolean>(false)
    const [UploadError, setUploadError] = useState<boolean>(false)
    const history = useHistory();


    console.log(props.location.state)
    useEffect(() => {
        const getEquipe = async () => {
            await fetch('https://admin.radioemotion.be/api/equipe/get', RequestInit as RequestInit)
                .then(response => response.json())
                .then(response => {
                    if (response.response === true) {
                        setEquipe(response.data);
                        console.log({ name: response.data.find((x: { Id: number, name: string, image: string }) => x.name === props.location.state.nom)?.Id, label: props.location.state.nom })
                        setSelectedEquipe({ name: response.data.find((x: { Id: number, name: string, image: string }) => x.name === props.location.state.nom)?.Id, label: props.location.state.nom })
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
        const getDaysOfEmission = async () => {
            await fetch('https://admin.radioemotion.be/api/emissions/getdaysofemission', RequestInitWithBody({ body: { Id: props.location.state.emission_Id }, type: 'POST' }) as RequestInit)
                .then(response => response.json())
                .then(response => {
                    if (response.response === true) {
                        console.log(response.data)
                        response.data.map((data: { Id: number, jour: string }) => {
                            setSelectedJour((prevArray: any) => [...prevArray, Weekdayconverter(data.jour)])
                            setActiveDays((prevArray: any) => [...prevArray, data.jour])
                        })
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
        getEquipe();
        getDaysOfEmission();
    }, []);

    const changeIMG = (value: FileList) => {

        if (value.length === 1) {
            console.log(value[0])
            if (value[0].type === "image/jpeg" || value[0].type === "image/png" || value[0].type === "image/jpg") {
                setBanniereIMG(URL.createObjectURL(value[0]))
                setErrorImage('')
            } else {
                setBanniereIMG(props.location.state.emission_banniere)
                setErrorImage("Veuillez sélectioner un fichier supporé")
                setBanniereUploadedUrl(value[0])
            }
        } else {
            setErrorImage('')
            setBanniereIMG(props.location.state.emission_banniere)
            console.log(value[0])

        }

    }

    const updateEmission = async () => {
        setUploadError(false)
        // console.log('did not get changed ' + ActiveDays.filter((x: string) => SelectedJour.includes(`${Weekdayconverter(x)}`)))
        // console.log('did get added ' + SelectedJour.filter((x: string) => !ActiveDays.includes(`${Weekdayconverter(x)}`)))
        // console.log('did get deleted ' + ActiveDays.filter((x: string) => !SelectedJour.includes(`${Weekdayconverter(x)}`)))
        const ToDelete = ActiveDays.filter((x: string) => !SelectedJour.includes(`${Weekdayconverter(x)}`))
        const ToAdd = SelectedJour.filter((x: string) => !ActiveDays.includes(`${Weekdayconverter(x)}`));
        let ToDeleteArray: number[] = []
        ToDelete.map((element: any) => {
            ToDeleteArray.push(jour.indexOf(element) + 1)
        })
        let ToAddArray: number[] = [];
        ToAdd.map((element: any) => {
            ToAddArray.push(days.indexOf(element) + 1)
        });
        console.log(Desription.replace(/↵↵/g,'\n'))
        await fetch('https://admin.radioemotion.be/api/emission/updatefull', RequestInitWithBody({
            body: {
                Emission_Id: props.location.state.emission_Id,
                Emission: Emission,
                Description: Desription.replace(/\r?\n/g, "\\n").replace(/"/g, '\\"'),
                Heure_Debut: Heure_Debut,
                Heure_Fin: Heure_Fin,
                Equipe_Id: SelectedEquipe.name,
                BanniereActive: BanniereActive,
                ToDeleteEmission: ToDeleteArray,
                ToAddEmission: ToAddArray,
                Image: BanniereIMG === props.location.state.emission_banniere ? null : BanniereIMG
            }, type: 'PUT'
        }) as RequestInit)
            .then(response => response.json())
            .then(response => {
                if (response.response === true) {
                    console.log(response.response)
                    history.push({ pathname: '/emission/listallemission', state: { passed: true, message: `L'emission a été mise à jour ` } })
                } else {
                    setUploadError(true)
                }

            })
            .catch(err => {
                console.log(err)
                setUploadError(true)
            })
    }

    return (
        <>
            { UploadError ?
                <>
                    <ShowNotification
                        icon="times"
                        iconClassName="color-red"
                        bodyClassName="background-color-red text-white"
                        autohide={5000}
                        title=""
                        message="Une erreur s'est produite"
                        text="maintenant"
                    />
                </> : null
            }
            <MDBContainer className="min-h-100vh">
                <MDBRow className="mb-5 mt-2">
                    <Link to='/emission/listallemission'>
                        <Button
                            variant="neutral"
                            className='mt-2'
                        > <FontAwesomeIcon icon={faHome} className="py-1" size='2x' /></Button>
                    </Link>
                </MDBRow>

                <MDBRow className="mb-5">
                    <form encType="multipart/form-data" className="w-100" >
                        <MDBRow className="mb-5">
                            <MDBCol md={"12"} xs={"12"} sm={"12"} className="mb-5">
                                <Card footer={<h1>Banniere</h1>}>
                                    <img src={BanniereIMG} className="h-75 w-100" ></img>
                                </Card>
                            </MDBCol>

                            <MDBCol md={"4"} xs={"12"} sm={"12"}>
                                <FileSelector
                                    label="Selecteur de fichier"
                                    placeholder="Glisser & déposer ou cliquer pour parcourir"
                                    bottomHelpText="Selectionez seulement un fichier"
                                    onChange={value => changeIMG(value)}
                                    error={errorImage}
                                />
                            </MDBCol>
                            <MDBCol md={"4"} xs={"12"} sm={"12"}>
                                <CheckboxToggle
                                    id="checkbox-toggle-component-1"
                                    label={`Banniere ${BanniereActive === 1 ? 'activé' : 'desactivé'}`}
                                    className='d-flex h-100'
                                    value={BanniereActive === 1 ? true : false}
                                    onChange={(event: React.ChangeEvent<HTMLElement>) => setBanniereActive(BanniereActive === 1 ? 0 : 1)}
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md={"12"} xs={"12"} sm={"12"} className="mb-5">
                                <Textarea
                                    id="emissionNome"
                                    label="Titre de l'emission "
                                    placeholder="Titre de l'emission"
                                    value={Emission}
                                    onChange={event => setEmission(event.target.value)}
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md={"12"} xs={"12"} sm={"12"} className="mb-5">
                                <Textarea
                                    id="actualiteCreateTitre"
                                    label="Description de l'emission"
                                    rows={2}
                                    placeholder="Description de l'emission"
                                    grow={true}
                                    onChange={e => { setDesription(e.target.value); { e.target.value === '' ? setErrorDesription("Le titre est obligatoire") : setErrorDesription('') } }}
                                    value={Desription}
                                    error={errorDesription}
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md={"3"} xs={"12"} sm={"12"}>
                                <TimePicker
                                    value={Heure_Debut}
                                    label="Heure de début"
                                    hour24
                                    onChange={value => setHeure_Debut(value)}
                                />
                            </MDBCol>
                            <MDBCol md={"3"} xs={"12"} sm={"12"}>
                                <TimePicker
                                    value={Heure_Fin}
                                    label="Heure de fin"
                                    hour24
                                    onChange={value => setHeure_Fin(value)}

                                />
                            </MDBCol>
                            <MDBCol md={"3"} xs={"12"} sm={"12"}>
                                <WeekDayPicker
                                    locale={'FR-be'}
                                    value={SelectedJour}
                                    id="weekday-picker-15"
                                    multiple
                                    label={`Jour de l'emission`}
                                    onChange={(e) => { setSelectedJour(e); console.log(e) }}
                                />
                            </MDBCol>
                            <MDBCol md={"3"} xs={"12"} sm={"12"}>
                                <Picklist
                                    value={SelectedEquipe}
                                    label={props.location.state.nom}
                                    onChange={(value) => { setSelectedEquipe({ name: value.name, label: value.label }) }}
                                    enableSearch

                                >
                                    {Equipe.map((data: { Id: number, name: string, image: string }) => (
                                        <Option key={data.Id} name={data.Id} label={data.name} />
                                    ))}
                                </Picklist>
                            </MDBCol>
                        </MDBRow>
                    </form>
                </MDBRow>
                <MDBRow end>
                    <Button
                        isLoading={loading}
                        label='Mettre à jour'
                        onClick={() => updateEmission()}
                        variant="brand"
                        className='mt-2 mb-4 font-weight-bold'
                    />
                </MDBRow>
            </MDBContainer>
        </>
    )
}

export default UpdateFullEmission
